import React, {PropTypes} from 'react';
import classNames from 'classnames';
import { FormattedMessage, injectIntl } from 'react-intl';
import _ from 'lodash';

import PureRenderComponent from 'app/lib/PureRenderComponent';
import * as businessRules from 'app/businessRules';
import * as VERIFY_STATUS from 'modules/visits/constants/unitVerificationStatus';

import ButtonGroup from 'routes/app/components/ButtonGroup';
import Input from 'routes/app/components/Input';
import Select from 'routes/app/components/Select';
import Button from 'routes/app/components/Button';
import Preloader from 'routes/app/components/Preloader';
import Row from 'routes/app/components/Row';
import Col from 'routes/app/components/Col';
import CardPanel from 'routes/app/components/CardPanel';
import GoodsTable from './GoodsTable';
import DocsTable from './DocsTable';
import UnitReasons from '../VisitOverview/Visit/UnitReasons/UnitReasons';


class UnitForm extends PureRenderComponent {

    static propTypes = {
        trac: PropTypes.object,
        dim: PropTypes.object,
        inOut: PropTypes.object,
        netto: PropTypes.object,
        rid: PropTypes.object,
        empty: PropTypes.object,
        reference: PropTypes.object,
        pos: PropTypes.object,
        unitKind: PropTypes.object,
        ctNumber: PropTypes.object,

        visitDate: PropTypes.string,
        vtrac: PropTypes.string,
        visitLicensePlate: PropTypes.string,
        packUnity: PropTypes.array,
        docTypes: PropTypes.array,
        unitKinds: PropTypes.array,
        className: PropTypes.string,
        onCancel: PropTypes.func,//.isRequired,
        onSubmit: PropTypes.func,//.isRequired,
        verifyUnit: PropTypes.func,
        unitVerification: PropTypes.object,
        ISO: PropTypes.object,
        goods: PropTypes.array,
        docs: PropTypes.array,
        saveGood: PropTypes.func,
        getDocs: PropTypes.func,
        deleteGood: PropTypes.func.isRequired,
        intl: PropTypes.object,//.isRequired
        skipGoodsDocsEntry: PropTypes.bool.isRequired
    };

    getDimensions = () => {
        let dims = _.clone(this.props.unitVerification.dims);
        if (this.props.dim.value && !_.find(dims, {desc:this.props.dim.value})) {
            dims.push({desc:this.props.dim.value});
        }
        return dims;
    };

    render() {

        let {className, onCancel, onSubmit,
            ISO, goods, good,
            docs, doc,
            visitDate, visitLicensePlate, unitKinds,
            packUnity,
            docTypes,
            saveGood,
            deleteGood,
            saveDoc,
            deleteDoc,
            getDocs,
            vtrac,
            ...props} = this.props;

        let {trac, dim, inOut, netto, rid, empty, reference, pos, unitKind, ctNumber, verifyUnit, unitVerification, reasons, skipGoodsDocsEntry} = this.props;

        let {formatMessage} = this.props.intl;

        let classes = {};

        if (!inOut) {
            return <div>...</div>;
        }

        return (<div className={classNames(classes, className)} {...props}>

            <Row>
                <Col s={12}>
                    <CardPanel className="unit__visit-summary">
                        <FormattedMessage id="unit.visit_summary" />
                        <ul>
                            {visitDate && <li><label><FormattedMessage id="label_date" /></label>: {visitDate}</li>}
                            {vtrac && <li><label><FormattedMessage id="visit.trac" /></label>: {vtrac}</li>}
                            {visitLicensePlate && <li><label><FormattedMessage id="label_licenseplate" /></label>: {visitLicensePlate}</li>}
                        </ul>
                    </CardPanel>
                </Col>
                {reasons.value && reasons.value.length ?
                    <Col s={12} m={6}>
                        <CardPanel className="unit__visit-summary">
                            <UnitReasons reasons={reasons.value} />
                        </CardPanel>
                    </Col> : null
                }
            </Row>

            <h2><FormattedMessage id="unit.heading.unitRequest" /></h2>

            <Row>
                <Input s={6} type="radio" name="type" className="with-gap"
                       id="drop-off" label={<FormattedMessage id="unit.type.i" />}
                       {...inOut} value="I" checked={inOut.value === 'I'} />

                <Input s={6} type="radio" name="type" className="with-gap"
                       id="pick-up" label={<FormattedMessage id="unit.type.o" />}
                       {...inOut} value="O" checked={inOut.value === 'O'} />
            </Row>
            <Row>
                <Input s={6} type="radio" name="empty" className="with-gap"
                       label={<FormattedMessage id="unit.empty.0" />}
                       {...empty} value="0" checked={empty.value === "0"} />

                <Input s={6} type="radio" name="empty" className="with-gap"
                       label={<FormattedMessage id="unit.empty.1" />}
                       {...empty} value="1" checked={empty.value === "1"} />
            </Row>
            <Row>
                <Input s={12} m={6} label={<FormattedMessage id="unit.ref" />} {...reference} />

                {businessRules.showUnitField(this.props, 'unitKind') &&
                <Select s={12} m={6} id="unitKind" type="select" label={<FormattedMessage id="unit.label.unitKind" />}
                        options={unitKinds} optionValue="code" optionLabel="desc"
                    {...unitKind} />
                }

                <Input s={12} m={6} label={<FormattedMessage id="unit.ctNumber" />} {...ctNumber} />

                {businessRules.showUnitField(this.props, 'rid') &&
                <div className="section clearfix">
                    <Input s={12} m={6} label={<FormattedMessage id="unit.label.hazardous" />} type="checkbox" className="filled-in" {...rid} />
                </div>
                }

            </Row>

            <Row>
                <ButtonGroup>
                    {businessRules.showVerifyButton(this.props) ?
                        <Col s={12}>

                            {unitVerification.status === VERIFY_STATUS.VERIFIED_NOK && unitVerification.dims.length === 0 &&
                            <span className="msg-error"><FormattedMessage id="unit.form.verify.failed" /> </span>
                            }
                            {unitVerification.status === VERIFY_STATUS.VERIFIED_OK &&
                            <span className="msg-success"><FormattedMessage id="unit.form.verify.success"/> </span>
                            }

                            {unitVerification.status === VERIFY_STATUS.VERIFYING ?
                                <Preloader size="small" flashing/> :
                                <Button waves="light" className="btn-secondary" onClick={() => {dim.onChange('');verifyUnit();}}><FormattedMessage id="unit.button.verify" /></Button>
                            }
                        </Col>
                        :
                        <Col s={12}>
                            <Button disabled><FormattedMessage id="unit.button.verify" /></Button>
                        </Col>}
                </ButtonGroup>
            </Row>

            <Row>

                {/*businessRules.showUnitField(this.props, 'ISO') && businessRules.unitKindHasISO(unitKind.value) &&
                 <Input s={12} m={6} id="ISO" label={<FormattedMessage id="unit.label.iso" />} {...ISO} />
                 */}


                {businessRules.showUnitField(this.props, 'netto', unitVerification) &&
                <Input s={12} m={6} label={<FormattedMessage id="unit.label.netto" />} {...netto} />
                }


                {businessRules.showUnitField(this.props, 'dim', unitVerification) &&
                <Select s={12} id="equipment" label={<FormattedMessage id="unit.label.lengthLWH" />}
                        options={this.getDimensions()} optionValue="desc" optionLabel="desc"
                    {...dim} />
                }

                {businessRules.showUnitField(this.props, 'pos', unitVerification) &&
                    <div className=" clearfix">
                        <Col s={12}><label><FormattedMessage id="unit.pos" /></label></Col>
                        <Input s={4} type="radio" name="pos" className="with-gap"
                               label={<FormattedMessage id="unit.pos.F" />}
                            {...pos} value="F" checked={pos.value === 'F'}/>
                        <Input s={4} type="radio" name="pos" className="with-gap"
                               label={<FormattedMessage id="unit.pos.M" />}
                            {...pos} value="M" checked={pos.value === 'M'}/>
                        <Input s={4} type="radio" name="pos" className="with-gap"
                               label={<FormattedMessage id="unit.pos.B" />}
                            {...pos} value="B" checked={pos.value === 'B'}/>
                    </div>
                }



                {/*
                 <Input s={12} m={6} id="equipment" type="select" label="Equipment type" {...equipment} >
                 <option>Not specified</option>
                 <option>A</option>
                 <option>B</option>
                 <option>C</option>
                 <option>D</option>
                 </Input>
                 */}

            </Row>

            {!skipGoodsDocsEntry && businessRules.showUnitField(this.props, 'goodsOverview') &&
                <GoodsTable
                            goods={goods}
                            goodForm={good}
                            activeGood={goods[goods.length - 1]}
                            packUnity={packUnity}
                            hazardous={rid.value}
                            addGood={() => {
                                goods.addField();
                            }}
                            removeGood={(id) => deleteGood(trac.value, id)}
                            translate={formatMessage}
                            saveGood={()=>{saveGood(trac.value);}} />
            }

            {!skipGoodsDocsEntry && businessRules.showUnitField(this.props, 'docsOverview') &&
                <DocsTable
                    docs={docs}
                    docForm={doc}
                    docTypes={docTypes}
                    hazardous={rid.value}
                    removeDoc={(id) => deleteDoc(trac.value, id)}
                    translate={formatMessage}
                    getDocs={()=>{getDocs({trac:trac.value});}}
                    saveDoc={()=>{saveDoc(trac.value);}} />
            }


            <ButtonGroup>
                {businessRules.showSaveUnitButton(this.props, unitVerification) &&
                <span>
                    <Button waves="light" onClick={onSubmit}><FormattedMessage id="unit.button.save" /></Button>
                    {' '}
                    <Button waves="light" onClick={()=>{onSubmit();onCancel();}}><FormattedMessage id="unit.button.saveAndClose" /></Button>
                    {' '}
                </span>}
                <Button flat waves="light" onClick={onCancel}><FormattedMessage id="unit.button.cancel" /></Button>
            </ButtonGroup>

        </div>
        );
    }

}

export default injectIntl(UnitForm);
